import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import config from '../../config'

import {
  IGetPostRequest,
  IUseAddMutation,
  IAddFn,
  ISafetyCase,
  ISafetyCaseStatusAddUpsert,
} from '../../interfaces'

const getCreateSafetyCaseStatusMutationRequest: IGetPostRequest = () => ({
  method: 'post',
  url: `${config.baseUrl}/sms/SafetyCaseStatuses`,
})

const useCreateSafetyCaseStatusMutation: IUseAddMutation<ISafetyCase, ISafetyCaseStatusAddUpsert> = (
  params,
  options = {},
) => {
  const request = useMemo(() => getCreateSafetyCaseStatusMutationRequest(params), [params])

  const createSafetyCaseStatus: IAddFn<ISafetyCaseStatusAddUpsert, ISafetyCase> = useCallback(
    async data => axios({ ...request, data }).then(res => res.data),
    [request],
  )

  const response = useMutation<ISafetyCase, Error, ISafetyCaseStatusAddUpsert>({
    mutationFn: createSafetyCaseStatus,
    ...options,
  })

  return response
}

export default useCreateSafetyCaseStatusMutation
